import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'

import RequireUserSwitchMessage from 'components/Errors/Messages/RequireUserSwitchMessage'
import { DevErrorViewContext } from 'components/Errors/DevErrorView'

const DEV_TEST_DATA = {
    expectedRole: 'seller',
    switchUserEmail: 'test@email.com'
}

const BosRoleSwitchMessage = ({ t, appError }) => {
    let data = appError.data

    const devErrorContext = useContext(DevErrorViewContext)

    if (devErrorContext) {
        data = DEV_TEST_DATA
    }

    const { expectedRole, switchUserEmail } = data

    if (!['seller', 'buyer'].includes(expectedRole)) {
        throw new Error(`Invalid expectedRole "${expectedRole}"`)
    }

    const role = expectedRole.toLowerCase()

    return (
        <RequireUserSwitchMessage
            title={t(`errors:internal.1007.${role}.title`)}
            description={t(`errors:internal.1007.${role}.description`)}
            logoutButtonText={t(`errors:internal.1007.${role}.login`)}
            switchUserEmail={switchUserEmail}
        />
    )
}

BosRoleSwitchMessage.propTypes = {
    appError: PropTypes.object.isRequired,
}

export default withTranslationCustom('errors')(BosRoleSwitchMessage)
